var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-select",
    _vm._g(
      _vm._b(
        {
          ref: "select",
          staticClass: "el-select-v2",
          attrs: {
            autocomplete: _vm.autocomplete,
            "automatic-dropdown": _vm.automaticDropdown,
            size: _vm.size,
            disabled: _vm.disabled,
            clearable: _vm.clearable,
            filterable: _vm.filterable,
            "allow-create": false,
            loading: _vm.loading,
            "popper-class": `el-select-v2__popper ${_vm.popperClass || ""}`,
            remote: _vm.remote,
            "loading-text": _vm.loadingText,
            "no-match-text": _vm.noMatchText,
            "no-data-text": _vm.noDataText,
            "remote-method": _vm.remoteMethod,
            "filter-method": _vm.localFilterMethod,
            multiple: _vm.multiple,
            "multiple-limit": _vm.multipleLimit,
            placeholder: _vm.placeholder,
            "reserve-keyword": _vm.reserveKeyword,
            "collapse-tags": _vm.collapseTags,
            "popper-append-to-body": _vm.popperAppendToBody,
            "value-key": _vm.valueKey,
          },
          model: {
            value: _vm.localValue,
            callback: function ($$v) {
              _vm.localValue = $$v
            },
            expression: "localValue",
          },
        },
        "el-select",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm.$slots.header
        ? _c(
            "div",
            { staticClass: "el-select-dropdown__header" },
            [_vm._t("header")],
            2
          )
        : _vm._e(),
      _vm.localOptions.length
        ? _c("RecycleScroller", {
            ref: "scroller",
            staticClass: "scroller",
            style: _vm.scrollerStyle,
            attrs: {
              items: _vm.localOptions,
              "min-item-size": _vm.minItemSize,
              "key-field": _vm.aliasProps.value,
            },
            on: { visible: _vm.handleScrollerVisible },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function ({ item }) {
                    return [
                      item._isGroup
                        ? _c("li", { staticClass: "el-select-group__title" }, [
                            _vm._v(
                              " " + _vm._s(item[_vm.aliasProps.label]) + " "
                            ),
                          ])
                        : _c(
                            "el-option",
                            {
                              key: _vm.getOptionKey(item),
                              attrs: {
                                value: item[_vm.aliasProps.value],
                                label: item[_vm.aliasProps.label],
                                disabled: item[_vm.aliasProps.disabled],
                              },
                              nativeOn: {
                                mousemove: function ($event) {
                                  return _vm.hoverItem(item)
                                },
                              },
                            },
                            [_vm._t("default", null, { item: item })],
                            2
                          ),
                    ]
                  },
                },
              ],
              null,
              false,
              3502383140
            ),
          })
        : _vm._e(),
      _vm.$slots.footer
        ? _c(
            "div",
            { staticClass: "el-select-dropdown__footer" },
            [_vm._t("footer")],
            2
          )
        : _vm._e(),
      _vm.$slots.prefix
        ? _c("template", { slot: "prefix" }, [_vm._t("prefix")], 2)
        : _vm._e(),
      _vm.$slots.empty
        ? _c("template", { slot: "empty" }, [_vm._t("empty")], 2)
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }